import React from 'react';

/* ────────────────────────────────────────────────────────────────────────
 * Inline SVG icons — thin pink strokes, rounded caps, matching the
 * screenshot's line-icon style. Swap these for your real icon files
 * whenever you have them; each one just needs to accept `size`.
 * ──────────────────────────────────────────────────────────────────── */

const iconProps = (size) => ({
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
});

const ExpertsIcon = ({ size = 28 }) => (
  <svg {...iconProps(size)}>
    <circle cx="8.5" cy="7" r="3" />
    <path d="M2 20c0-3.3 2.9-6 6.5-6S15 16.7 15 20" />
    <circle cx="16.5" cy="8" r="2.3" />
    <path d="M15.5 13c2.9.3 5 2.6 5 5.5" />
  </svg>
);

const TechnologyIcon = ({ size = 28 }) => (
  <svg {...iconProps(size)}>
    <path d="M5 21V8.5L12 3l7 5.5V21" />
    <path d="M9 21v-6h6v6" />
    <path d="M12 8v4" />
    <path d="M10 10h4" />
  </svg>
);

const CarePlansIcon = ({ size = 28 }) => (
  <svg {...iconProps(size)}>
    <rect x="5" y="4" width="14" height="17" rx="2" />
    <path d="M9 3.5h6a1 1 0 0 1 1 1V6H8V4.5a1 1 0 0 1 1-1Z" />
    <path d="m9 12 2 2 4-4" />
    <path d="M9 17h6" />
  </svg>
);

const ConfidentialIcon = ({ size = 28 }) => (
  <svg {...iconProps(size)}>
    <path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3Z" />
    <path d="M12 8.5c1.1 0 2 .8 2 1.9 0 1.5-2 3.1-2 3.1s-2-1.6-2-3.1c0-1.1.9-1.9 2-1.9Z" />
  </svg>
);

const InsuranceIcon = ({ size = 28 }) => (
  <svg {...iconProps(size)}>
    <rect x="3" y="6" width="18" height="13" rx="2" />
    <path d="M3 10h18" />
    <circle cx="16.5" cy="14.5" r="1.6" />
  </svg>
);

/* ────────────────────────────────────────────────────────────────────────
 * TrustBadges — "Why thousands of women trust HerCare" card
 *
 * Uses the same CSS-variable conventions as the rest of the site
 * (var(--primary-color), var(--text-dark), var(--text-light), etc).
 * If your variable names differ from these, swap them — the structure
 * and layout stay the same either way.
 * ──────────────────────────────────────────────────────────────────── */

const items = [
  {
    id: 'experts',
    icon: '/Home/healthExpert.svg',
    text: ["Experienced", "Women's Health Experts"],
  },
  {
    id: 'technology',
    icon: '/Home/clinic.svg',
    text: ['Advanced Technology', '& Facilities'],
  },
  {
    id: 'care-plans',
    icon: '/Home/carePlan.svg',
    text: ['Personalized', 'Care Plans'],
  },
  {
    id: 'confidential',
    icon: '/Home/privacy.svg',
    text: ['Safe, Confidential', '& Compassionate'],
  },
  {
    id: 'insurance',
    icon: '/Home/cashless.svg',
    text: ['Insurance & Cashless', 'Options'],
  },
    {
    id: 'privacy',
    icon: '/Home/privacyAndCompliance.svg',
    text: ['Privacy & Compliance'],
  },
];

const TrustBadges = () => {
  return (
    <div
      className="w-full  mb-10"
      style={{
        // background:
        //   'linear-gradient(180deg, rgba(255, 241, 244, 0.7) 0%, rgba(255, 250, 251, 0.4) 100%)',
        background:"linear-gradient(180deg, var(--ava-color-primary-50) 0%, rgba(255, 250, 251, 0.4) 100%)",
        // border: '1px solid var(--primary-color)',
        // boxShadow:" rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"
        boxShadow:"rgba(0, 0, 0, 0.07) 0px 2px 16px"
      }}
      
    >
      <div className="container mx-auto px-6 md:px-10 py-7 md:py-8">
        {/* ── Heading ── */}
        <h3
          className="text-center font-bold mb-6 md:mb-8"
          style={{
            fontSize: 'clamp(1.1rem, 2vw, 1.4rem)',
            color: 'var(--text-dark, #1a1a2e)',
          }}
        >
          {/* Why thousands of women trust HerCare */}
          Why thousands of women trust us ?
        </h3>

        {/* ── Items row ── */}
        {/* <div className="flex flex-col md:flex-row items-center md:items-stretch justify-between gap-5 md:gap-0">
          {items.map((item, index) => {
            const Icon = item.icon;
            return (
              <React.Fragment key={item.id}>
                <div className="flex items-center gap-3 md:flex-1 md:justify-center">
                 
                  <img src={item.icon} style={{height:25}} alt={item.icon}/>
                  <p
                    className="text-sm leading-snug"
                    style={{ color: 'var(--text-light, #6b7280)' }}
                  >
                    {item.text[0]}
                    <br />
                    {item.text[1]}
                  </p>
                </div>

                {index < items.length - 1 && (
                  <div
                    className="hidden md:block self-stretch"
                    style={{ width: 1, background: 'var(--gray-300, #e5e7eb)', margin: '0 4px' }}
                  />
                )}
              </React.Fragment>
            );
          })}
        </div> */}
        {/* ── Items row ── */}
<div className="flex flex-col md:flex-row items-stretch md:items-stretch justify-between gap-5 md:gap-0 mx-auto max-w-xs md:max-w-none">
  {items.map((item, index) => {
    return (
      <React.Fragment key={item.id}>
        <div className="grid grid-cols-[28px_1fr] gap-3 items-center md:flex-1 md:justify-center md:flex md:items-center">
          <img src={item.icon} style={{ height: 25 }} alt={item.icon} className="justify-self-start" />
          <p
            className="text-sm leading-snug text-left"
            style={{ color: 'var(--text-light, #6b7280)' }}
          >
            {item.text[0]}
            <br />
            {item.text[1]}
          </p>
        </div>

        {index < items.length - 1 && (
          <div
            className="hidden md:block self-stretch"
            style={{ width: 1, background: 'var(--gray-300, #e5e7eb)', margin: '0 4px' }}
          />
        )}
      </React.Fragment>
    );
  })}
</div>
      </div>
    </div>
  );
};

export default TrustBadges;